<template>
    <svg :width="96" :height="96" viewBox="0 0 96 96" :style="{ height: `${size}px`, width: `${size}px` }">
        <g v-if="icon === 'advanced_materials'" :fill="color">
            <path class="cls-1" d="M10,25c5,17,25,25,36,27s14.5,4.5,18,9c-2.5,2.5-11.5,7.5-14.5,9.5-2-6-.5-14.5-.5-14.5a28,28,0,0,0-9-3c-4,18,2.5,28.5,8,37,6.5-2.5,10.6-6.25,10-6l-6-9s10.5-7.5,16-10c3.5,2.5,6.5,10.5,6.5,10.5A89.69,89.69,0,0,0,84,70C75,46,50,44,50,44S31.5,38.5,29,31c5.5-3.5,6.5-4.5,12-8,4,6,3,15,3,15a38.72,38.72,0,0,0,10,3c4-17-4-32-9-36a87.94,87.94,0,0,0-10,6,18.15,18.15,0,0,1,3.5,7.5L27,26l-6-8S16,21,10,25Z"/>
            <path class="cls-1" d="M71.5,18.5c1,2-6,14-11,18C61.5,31.5,64.5,19.5,71.5,18.5Z"/>
            <path class="cls-1" d="M28.5,55.5c0,4-6,14-14,12C14.5,65.5,25.5,59.5,28.5,55.5Z"/>
            <path class="cls-1" d="M24.5,52.5c-4-1-13-1-12,2C13.5,58.5,21.5,56.5,24.5,52.5Z"/>
            <path class="cls-1" d="M70.5,41.5s10-1,10,4C75.5,48.5,70.5,41.5,70.5,41.5Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        size: {
            type: Number,
            default: 32
        },
        icon: {
            type: String,
            default: 'advanced_materials'
        },
        color: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>
